'use client';
import { downloadFileAttachment } from '#pplx/frontend/apps/ask/queries/mutations/filesMutations.js';
import { getImageDownloadUrlQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/fileKeys.js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
export const useGetImageDownloadUrl = ({ reason, }) => {
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutation({
        mutationKey: getImageDownloadUrlQueryKey(),
        mutationFn: async (req) => {
            const response = await downloadFileAttachment({
                request: {
                    url: req.url,
                    thread_id: req.thread_id,
                },
                reason,
            });
            return response.file_url;
        },
        onSuccess: (data, variables, _) => {
            queryClient.setQueryData(getImageDownloadUrlQueryKey(variables.url), data);
            variables.callback?.(data, false);
        },
        onError: (_, variables, __) => {
            variables.callback?.('', false);
        },
        retry: false,
    });
    const getCachedImageDownloadUrl = useCallback((secure_url) => {
        const result = queryClient.getQueryData(getImageDownloadUrlQueryKey(secure_url));
        return typeof result === 'string' ? result : null;
    }, [queryClient]);
    const getImageDownloadUrl = useCallback(async (request, options) => {
        request.callback?.('', true);
        const cachedUrl = options?.forceRefresh ? null : getCachedImageDownloadUrl(request.url);
        if (cachedUrl) {
            request.callback?.(cachedUrl, false);
            return cachedUrl;
        }
        const result = await mutateAsync(request);
        request.callback?.(result, false);
        return result;
    }, [getCachedImageDownloadUrl, mutateAsync]);
    const cacheImageDownloadUrl = useCallback(async (url, file) => {
        const objectUrl = URL.createObjectURL(file);
        queryClient.setQueryData(getImageDownloadUrlQueryKey(url), objectUrl);
    }, [queryClient]);
    return useMemo(() => ({
        getCachedImageDownloadUrl,
        getImageDownloadUrl,
        cacheImageDownloadUrl,
    }), [cacheImageDownloadUrl, getCachedImageDownloadUrl, getImageDownloadUrl]);
};
//# sourceMappingURL=useGetImageDownloadUrl.js.map